import React, { forwardRef, useEffect } from 'react';
import { useEnsuredForwardedRef } from 'react-use';
import classNames from 'classnames';
import Portal from '../../Portal';
import ModalManager from './ModalManager';
import styles from './Modal.module.css';

const defaultModalManager = new ModalManager(document.body);

const Modal = forwardRef(function Modal(
  { open, hideBackdrop, manager = defaultModalManager, className, onClose, children, ...rest },
  forwardedRef
) {
  const modalRef = useEnsuredForwardedRef(forwardedRef);

  useEffect(() => {
    if (open) {
      return manager.register(modalRef.current);
    }
  }, [modalRef, manager, open]);

  if (!open) {
    return null;
  }

  return (
    <Portal container={manager.container}>
      <div ref={modalRef} className={classNames(styles.root, 'Everything', className)} {...rest}>
        {!hideBackdrop && <div className={styles.backdrop} onClick={console.log} />}
        {children}
      </div>
    </Portal>
  );
});

export default Modal;
